import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import BookingSection from "../components/BookingSection";
import QuoteSection from "../components/QuoteSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

export default function LandingPage() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="landing-page" className="bg-[#FAFAF5] min-h-screen">
      <Header />
      <Hero onScrollTo={scrollTo} />
      <Services onScrollTo={scrollTo} />
      <About />
      <BookingSection />
      <QuoteSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
